import React from 'react';
import { DailyItemSearch, DailyMarketSearch, DailyKeywordSearch, DailyCodeSearch } from "../containers/dailyDetail";
import { Helmet } from "react-helmet";


const HeadData = (
  <Helmet>
    <title>今日批發價格 | 農業視覺化</title>
    <meta name="description" content="農產品今日批發價格查詢，依品項、市場、代碼、關鍵字搜尋。" />
  </Helmet>
);

export default class Daily extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadItemData: true, //** to controll #daily-search-detail-selection-board
      loadMarketData: false,
      loadCodeData: false,
      loadKeywordData: false,
      tableDataArray: [],
      searchingTime: '',
      responseState: '',
      responseDataState: true
    }
    this.handleShowDetail = this.handleShowDetail.bind(this);
    this.handleGetAPIdata = this.handleGetAPIdata.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0); //** to load top of the page
  }

  async handleGetAPIdata(parameter, dataSet) {
    let requestURL = new Request('/daily');
    let dataParameter = null;

    switch (parameter) {
      case "crop":
        dataParameter = {
          CropCode: dataSet
        };
        break;
      
      case 'market':
        dataParameter = {
          marketName: dataSet
        };
        break;

      case 'CropCode':
        dataParameter = {
          CropCode: [dataSet]
        };
        break;

      default:
        break;
    }

    let requestInit = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dataParameter)
    };

    let response = await fetch(requestURL, requestInit);
    let collectAllData = await response.json();

    let searchingTime = `${ new Date().toLocaleString('zh-TW') }`;

    let responseDataState = true;
    
    for (let i=0; i<collectAllData.length; i++) {
      if (collectAllData[i].length !== 0) {
        responseDataState = true;
        break;
      } else {
        responseDataState = false;
      }
    }   

    this.setState({
      tableDataArray: collectAllData,
      searchingTime: searchingTime,
      responseDataState: responseDataState
    })
  }

  handleShowDetail(selection) {
    console.log(selection);

    switch (selection) {
      case 'items':
        this.setState({
          loadItemData: true,
          loadMarketData: false,
          loadCodeData: false,
          loadKeywordData: false
        });
       break;

      case 'markets':
        this.setState({
          loadItemData: false,
          loadMarketData: true,
          loadCodeData: false,
          loadKeywordData: false
        });
        break;
      
      case 'codes':
        this.setState({
          loadItemData: false,
          loadMarketData: false,
          loadCodeData: true,
          loadKeywordData: false
        });
        break;

      case 'keywords': 
        this.setState({
          loadItemData: false,
          loadMarketData: false,
          loadCodeData: false,
          loadKeywordData: true
        });
        break;  
      
      default:
        this.setState({
          loadItemData: false,
          loadMarketData: false,
          loadCodeData: false,
          loadKeywordData: false
        });
        break;
    }
  }

  render() {
    return (
      <section id="daily-page">
        { HeadData }
        <div id="daily-search-board">
          <ul id="daily-search-btn" >
            <li className={ this.state.loadItemData ? "btnOn" : "btnOff" } onClick={() => this.handleShowDetail('items')}>依品項</li>
            <li className={ this.state.loadMarketData ? "btnOn" : "btnOff" } onClick={() => this.handleShowDetail("markets")}>依市場</li>
            <li className={ this.state.loadCodeData ? "btnOn" : "btnOff" } onClick={() => this.handleShowDetail('codes')}>依代碼</li>
            <li className={ this.state.loadKeywordData ? "btnOn" : "btnOff" } onClick={() => this.handleShowDetail('keywords')}>關鍵字</li>
          </ul>
          
          <div id="daily-search-detail-selection-board">
            { <DailyItemSearch loadData={this.state.loadItemData}
                onChange={ (parameter, dataSet) => this.handleGetAPIdata(parameter, dataSet) }
            /> }
            
            { <DailyMarketSearch loadData={ this.state.loadMarketData }
                onChange={ (parameter, dataSet) => this.handleGetAPIdata(parameter, dataSet) }
            /> }

            { <DailyCodeSearch loadData={ this.state.loadCodeData }
                onChange={ (parameter, dataSet) => this.handleGetAPIdata(parameter, dataSet)}
              /> }

            { <DailyKeywordSearch loadData={ this.state.loadKeywordData } 
                onChange={ (parameter, dataSet) => this.handleGetAPIdata(parameter, dataSet) }
              /> }
          </div>
        </div> 
   
        <div id="daily-info-board" >
          <div>
            <p className="info-title">查詢時間</p><p className="info-result">{ this.state.searchingTime }</p>
            <br/><p className="info-note">此價格為市場批發價</p>
          </div>
          <div id="scrollingTip">左右滑動表格查看詳細資訊</div>
        </div>
        
        <div id="daily-search-result-board">
          <table>
            <thead>
              <tr>        
                <th className="table-el table-first-el table-data-cropCode fixed-column">代碼</th>
                <th className="table-el table-data-cropName fixed-column">作物名稱</th>
                <th className="table-el table-data-market">交易市場</th>
                <th className="table-el table-data-date">交易日期<br/>(年/月/日)</th>
                <th className="table-el table-data-upperPrice">上價<br/>(元/公斤)</th>
                <th className="table-el table-data-mediumPrice">中價<br/>(元/公斤)</th>
                <th className="table-el table-data-lowerPrice">下價<br/>(元/公斤)</th>
                <th className="table-el table-data-avgPrice">平均價<br/>(元/公斤)</th>
                <th className="table-el table-last-el table-data-volumeOfTrade">交易量<br/>(公斤)</th>
              </tr>

            </thead>
            <tbody>
              { this.state.tableDataArray.map((resultArr) => {
                  let row = resultArr.map((singleArr, index) => {
                    return (
                      <tr key={ index + singleArr['作物代號'] } >
                        <td className="table-el table-first-el table-data-cropCode fixed-column">{ singleArr['作物代號'] }</td>
                        <td className="table-el table-data-cropName fixed-column">{ singleArr['作物名稱'] }</td>
                        <td className="table-el table-data-market">{ singleArr['市場名稱'] }</td>
                        <td className="table-el table-data-date">{ singleArr['交易日期'] }</td>
                        <td className="table-el table-data-upperPrice">{ singleArr['上價'] }</td>
                        <td className="table-el table-data-mediumPrice">{ singleArr['中價'] }</td>
                        <td className="table-el table-data-lowerPrice">{ singleArr['下價'] }</td>
                        <td className="table-el table-data-avgPrice">{ singleArr['平均價'] }</td>
                        <td className="table-el table-last-el table-data-volumeOfTrade">{ singleArr['交易量'] }</td>
                      </tr>
                    );
                  });
                  return row;
              }) }

              { this.state.responseDataState ? null : <tr className="response-no-data"><td>查無市場資料</td></tr>}
            </tbody>
          </table>
        </div>
      </section>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/daily.js